import { environment } from './../../../../environment/environment';
import { ApiResponse } from './../../models/response-api';
import { Injectable } from '@angular/core';
import { CrudService } from '../crud-service/crud.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CraEsnService extends CrudService<ApiResponse<any>, number> {
  constructor(_http: HttpClient) {
    super(_http, `${environment.baseUrl}/api`);
  }

  // @Decrypted
  /* LIST WORKFLOW GENERAL*/
  getAllListOfWorkFlowCra(company_id: any) {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/WorkFlowCra/getGeneralWorkFlowByCompanyId?company_id=${company_id}`
    );
  }

    /* LIST WORKFLOW GENERAL*/
  getListWorkFlow( data : any) {
    let page=1
    if(data?.page){
      page=data?.page + 1
    }
      return this._http.get<any>(
        `${this._base}/workflowCra/workflows/by-company?per_page=${data?.per_page}&page=${page}`
      );
  }

  //@decrypted
  /* detail workflow*/
  getWorkflowdetail(id: string) {
    return this._http.get<ApiResponse<any>>(
      this._base + `/workflowCra/workflow/details/${id}`
    );
  }
  getAllClient(esn_id: any) {
    return this._http.get<ApiResponse<any>>(
      this._base + `/EsnClient/getListClientsForWorkflow?esn_id=${esn_id}`
    );
  }
  getAllconsultantexterne(esn_name: any) {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/ConsultantEsn/getConsultantsforConsultantExterne?esn_name=${esn_name}`
    );
  }

  getWorkflowConsultants(esn_name: any) {
    return this._http.get<ApiResponse<any>>(
        `${this._base}/ConsultantEsn/getConsultantsforConsultantExterneForWorkflow?esn_name=${esn_name}`
    );
  }

  getUpdatedWorkflowConsultants(idWorkflow: number) {
    return this._http.get<ApiResponse<any>>(
        `${this._base}/workflowCra/getConsultantsForUpdateWorkflow/${idWorkflow}`
    );
  }

  /* LIST WORKFLOW CLIENT*/
  getListWorkflowClient(data?: {
    company_id: any;
    state_workflow: any;
    per_page?: number;
    page?: number;
    sort?: number;
    type?: number;
    sortAttribute?: string;
  }) {
    let sort = '';
    let sortAttr = '';
    if (data?.sort) {
      sort = `&sort=${data.sort}`;
      sortAttr = `&sortAttribute=${data?.sortAttribute}`;
    }
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/WorkFlowCra/getWorkFlowsByCompanyIdAndState?company_id=${data?.company_id}&state_workflow=2&per_page=${data?.per_page}&page=${data?.page}${sort}${sortAttr}`
    );
  }
  /* LIST WORKFLOW CONSULTANT*/
  getListWorkflowConsultant(data?: {
    company_id: any;
    state_workflow: any;
    per_page?: number;
    page?: number;
    sort?: number;
    type?: number;
    sortAttribute?: string;
  }) {
    let sort = '';
    let sortAttr = '';
    if (data?.sort) {
      sort = `&sort=${data.sort}`;
      sortAttr = `&sortAttribute=${data?.sortAttribute}`;
    }
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/WorkFlowCra/getWorkFlowsByCompanyIdAndState?company_id=${data?.company_id}&state_workflow=3&per_page=${data?.per_page}&page=${data?.page}${sort}${sortAttr}`
    );
  }
  /* create WorkFlow GENERAL */
  createWorkFlowForm(data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/workflowCra/workflow`,
      data
    );
  }
  /*delete workflow */
  deleteWorkflow(id: any): Observable<any> {
    const url = `${this._base}/workflowCra/workflow/${id}`;
    return this._http.delete(url);
  }
  /*update workflow */
  updateWorkflow(id: number, updatedData: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/WorkFlowCra/updateWorkFlow/${id}`,
      updatedData
    );
  }


  //@decrypted
  getAllListCra(
    esn_id: any,
    data: {
      per_page?: number;
      page?: number;
      sort?: number;
      sortAttribute?: string;
    }
  ) {
    let sort = '';
    if (data?.sort)
      sort = `&sort=${data.sort}&sortAttribute=${data.sortAttribute}`;
    console.log(`${this._base}'/Cra/listCraByESN?esn_id=${esn_id}&
        per_page=${data?.per_page}&page=${data?.page}${sort}`);
    return this._http.get<
      ApiResponse<any>
    >(`${this._base}/Cra/listCraByESN?esn_id=${esn_id}&
   per_page=${data?.per_page}&page=${data?.page}${sort}`);
  }
  /* search Cra */
  searchCra(data: any) {
    return this._http.post<any>(
      this._base + `/Cra/searchInListCRAsForEmployee`,
      data
    );
  }
  getDetailsCraJourfeerie(idCra: any) {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/Cra/getDetails?id=${idCra}`
    );
  }
  getClientsByCandidate(id: any,idCra: any,) {
    return this._http.get<ApiResponse<any>>(
      this._base + `/Cra/getClientsByCandidate?id=${id}&cra_id=${idCra}`
    );
  }
  getListTypeOfCra(cra_id : any) {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/SpecificTypeOfCra/getListWithoutPaginate?cra_id=${cra_id}`
    );
  }

  //@decrypted
  rejectAndValidateCra(data: any, companyId: any, userId: any) {
    return this._http.post<ApiResponse<any>>(
      this._base +
        `/Cra/validateCRAWithWorkflow?company_id=${companyId}&user_id=${userId}`,
      data
    );
  }

  validateOrRejectCra(data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base +
        `/Cra/validate-cra`,
      data
    );
  }

  getStateOffCra(idCra: any) {
    return this._http.get<ApiResponse<any>>(
      this._base + `/Cra/StateOfCra?cra_id=${idCra}`
    );
  }
  searchworkflow(data: any) {
    return this._http.post<any>(
      this._base +
        `/workflowCra/workflows/by-company?per_page=${data?.per_page}&page=${data?.page}`,
      data
    );
  }
 /**
 * Export a CRA as a file for the specified CRA ID and country.
 * The response is returned as a binary file (array buffer) suitable for downloading.
 *
 * @param idCra - The unique identifier of the CRA to be exported.
 * @param country - The country code for which the CRA is being exported (e.g., "FR").
 * @returns An Observable that emits the binary file data as an `ArrayBuffer`.
 */
  exportCra(idCra: number, country: string) {
    let url = `${this._base}/Cra/downloadCra?id=${idCra}&country=${country}`
    return this._http.get(url, {responseType: 'arraybuffer',});
  }

  getListCra(data : any){
    return this._http.get<any>(
      this._base + `/Cra/getCRAForEmployee?per_page=${data?.per_page}&page=${data?.page + 1}`
    );
  }
}
